import { makeVar } from '@apollo/client'

export const isExportLinkItemDisabledVar = makeVar(false)
